import React from "react";
import { usePageMeta } from "../seo";
import "../style/about.css";
import userData from "../data/userData.json";

/* Every overlay in src/img/overlay, one picked at random per page load — the
   same require.context arrangement the home-page gifs use, for the same
   reason: the folder is the list, so adding a .png there is all it takes.

   Module scope, so the choice is made once per load and held. Picking inside
   the component would swap the art on every re-render. */
const overlayContext = require.context("../img/overlay", true, /\.(png|jpe?g|webp)$/);
const OVERLAYS = overlayContext.keys().map(key => {
  const mod = overlayContext(key);
  return mod && mod.default ? mod.default : mod;
});
const OVERLAY = OVERLAYS.length
  ? OVERLAYS[Math.floor(Math.random() * OVERLAYS.length)]
  : null;

export default function About() {
  usePageMeta({
    title: "About",
    description:
      "Who Brutal Panda is — a security researcher writing about Windows " +
      "internals, malware analysis and offensive security technique.",
    path: "/about",
  });

  const { bio, credit, skills, profileImage } = userData.about;

  /* The fill animation used to be driven from here, resetting each bar's
     width and letting a rAF set it back. It was doing the same job as the
     fillBar keyframes in about.css, twice, and it addressed a class that no
     longer exists. The CSS owns it now. */

  /* Only the image URL crosses over from JS; everything about how it is
     drawn — size, opacity, how it answers the theme — stays in about.css.
     A custom property is what lets a random value do that, since the layer
     it belongs to is a pseudo-element no inline style can reach. */
  return (
    <div
      className="AboutMe-container"
      style={OVERLAY ? { "--about-overlay": `url("${OVERLAY}")` } : undefined}
    >

      {/* LEFT SIDE — TEXT */}
      <div className="bio">
        {bio.map((paragraph, index) => (
          <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />
        ))}
        {credit && (
          <p className="bio-credit" dangerouslySetInnerHTML={{ __html: credit }} />
        )}
      </div>

      {/* RIGHT SIDE — PROFILE + SKILLS */}
      <div className="right-side">

        <div className="profile-pic">
          {/* Intrinsic size matches the .profile-pic box so the circle does
              not collapse and reflow while the file is in flight. */}
          <img
            src={profileImage}
            alt="Profile"
            width="150"
            height="150"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div className="skills">
          <h4>My Skills</h4>

          {/* One line per skill: label, dot-matrix meter, bracketed reading.
              The meter is aria-hidden because the label and the number either
              side of it already say everything it shows. */}
          {skills.map((skill, index) => (
            <div className="skill-bar" key={index}>
              <span className="skill-name">{skill.name}</span>

              <span className="skill-meter" aria-hidden="true">
                <span
                  className="skill-meter__fill"
                  style={{
                    "--progress": `${Math.min(Math.max(skill.level, 0), 100)}%`
                  }}
                />
              </span>

              <span className="skill-pct">
                <span className="skill-pct__n">{skill.level}</span>%
              </span>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
